module.exports = __webpack_public_path__ + "static/media/background.d9a76fd7.jpg";